<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.manage_patient_data', {
          patient: $store.state.locale.patient.toUpperCase()
        })
      }}</span>
    </div>
    <div class="pt-30 page-card-content">
      <div class="section-title mb-15">
        {{
          $t('text.selected_patient', {
            patient: $store.state.locale.patient.toUpperCase()
          })
        }}
      </div>
      <patientInput class="dark-font-patient-input" />
      <div v-if="p('Patients.Archive')">
        <el-divider></el-divider>
        <div class="section-title mb-15">
          {{
            $t('text.archive_patient', {
              patient: $store.state.locale.patient.toUpperCase()
            })
          }}
        </div>
        <div class="mb-5 general-font">
          {{
            $t('text.archive_patient_warning', {
              patient: $store.state.locale.patient
            })
          }}
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :loading="archiveLoading"
          :disabled="archiveLoading || !$store.state.patient.selectedPatient"
          @click="archivePatient()"
          >{{
            $t('text.archive_patient_data', {
              patient: $firstLetterCapitalize($store.state.locale.patient)
            })
          }}</el-button
        >
      </div>
      <div v-if="p('Patients.Export')">
        <el-divider></el-divider>
        <div class="section-title mb-15">
          {{
            $t('text.export_patient', {
              patient: $store.state.locale.patient
            }).toUpperCase()
          }}
        </div>
        <div class="mb-5 general-font">
          {{
            $t('text.export_patient_history_data', {
              patient: $store.state.locale.patient
            })
          }}.
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :disabled="!$store.state.patient.selectedPatient"
          @click="showExportPatientData()"
          >{{
            $t('text.export_patient_data', {
              patient: $firstLetterCapitalize($store.state.locale.patient)
            })
          }}</el-button
        >
      </div>
      <div v-if="p('Patients.Delete')">
        <el-divider></el-divider>
        <div class="section-title mb-15">{{ $t('text.delete_account') }}</div>
        <div class="mb-5 general-font">
          {{ $t('text.data_management_desc') }}
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :loading="deleteLoading"
          :disabled="deleteLoading || !$store.state.patient.selectedPatient"
          @click="deletePatient()"
          >{{ $t('text.delete_account_data') }}</el-button
        >
      </div>
    </div>
    <ExportPatientData ref="exportPatientData" />
  </div>
</template>

<script>
import PatientInput from '@/components/patients/PatientInput.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import ExportPatientData from '@/components/manage/patients/ExportPatientData.vue'
export default {
  data() {
    return {
      consentChecked: false,
      deleteLoading: false,
      archiveLoading: false
    }
  },
  components: {
    PatientInput,
    ExportPatientData
  },
  methods: {
    archivePatient() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.$prompt('', this.$t('text.please_enter_comment'), {
        closeOnClickModal: false,
        confirmButtonText: this.$t('text.archive').toUpperCase(),
        cancelButtonText: this.$t('text.cancel').toUpperCase(),
        confirmButtonClass: 'danger-btn',
        inputType: 'textarea',
        inputValidator: input => {
          if (!input) {
            return this.$t('text.please_enter_comment')
          }
        }
      }).then(({ value }) => {
        this.handleArchive(value)
      })
    },
    handleArchive(comment) {
      this.archiveLoading = true
      ApiService.ArchivePatient({
        PatientId: this.$store.state.patient.selectedPatient.patientId,
        Comment: comment
      })
        .then(response => {
          this.archiveLoading = false
          if (response.data.success) {
            this.$bus.$emit('updatePatientDropdown')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.archived_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.archiveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Archived failed'
          })
        })
    },
    deletePatient() {
      if (!this.$store.state.patient.selectedPatient) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t('text.delete_patient_warning', {
          patient: this.$firstLetterCapitalize(this.$store.state.locale.patient)
        })}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          this.$store.state.patient.selectedPatient.alias,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeletePatient()
        })
        .catch(() => {})
    },
    handleDeletePatient() {
      this.deleteLoading = true
      ApiService.DeletePatient(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.deleteLoading = false
          if (response.data.success) {
            this.$bus.$emit('updatePatientDropdown')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.deleted_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.deleted_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.deleteLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.deleted_failed')
          })
        })
    },
    showExportPatientData() {
      this.$refs.exportPatientData.openDialog()
    }
  }
}
</script>
